module.exports = __webpack_public_path__ + "img/starting-learning-journey.cc6051b7.svg";